// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v5.26.1
// source: rtc/rocc.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../google/protobuf/timestamp";

export const protobufPackage = "carbon.rtc";

/**
 * A shared pool, a named queue of robots.
 * Watch pools and intervention pools can share the same underlying record
 */
export interface Pool {
  id: number;
  name: string;
}

/**
 * The long-running association between a robot and a pool.
 * When the robot comes online, this is the pool it will enter.
 */
export interface PoolAssignmentRobot {
  id: number;
  poolId: number;
  robotSerial: string;
}

/**
 * The long-running association between an intervener and a pool.
 * When the intervener clocks in, this is the pool they will read from.
 */
export interface PoolAssignmentIntervener {
  id: number;
  poolId: number;
  intervenerId: string;
}

/**
 * The long-running association between a watcher and a pool.
 * When the watcher clocks in, this is the pool they will read from.
 */
export interface PoolAssignmentWatcher {
  id: number;
  poolId: number;
  watcherId: string;
}

/** Watch Queue API */
export interface CreatePoolRequest {
  name: string;
}

export interface CreatePoolResponse {
  pool: Pool | undefined;
}

export interface GetPoolRequest {
  poolId: number;
}

export interface GetPoolResponse {
  pool: Pool | undefined;
}

export interface ListWatchPoolsRequest {
}

export interface ListWatchPoolsResponse {
  pageToken: string;
  pools: Pool[];
}

export interface DeletePoolRequest {
  poolId: number;
}

export interface DeletePoolResponse {
}

export interface AssignRobotRequest {
  poolId: number;
  robotSerial: string;
}

export interface AssignRobotResponse {
}

export interface UnassignRobotRequest {
  robotSerial: string;
}

export interface UnassignRobotResponse {
}

export interface GetRobotAssignmentRequest {
  robotSerial: string;
}

export interface GetRobotAssignmentResponse {
  assignment: PoolAssignmentRobot | undefined;
}

export interface ListPoolRobotsRequest {
  poolId: number;
}

export interface ListPoolRobotsResponse {
  assignments: PoolAssignmentRobot[];
}

/**
 * Lists robot pool assignments across all pools. An empty robot_serials
 * filter returns every assignment; otherwise only assignments for the given
 * serials are returned. Robots not assigned to any pool are simply absent
 * from the response.
 */
export interface ListRobotAssignmentsRequest {
  robotSerials: string[];
}

export interface ListRobotAssignmentsResponse {
  assignments: PoolAssignmentRobot[];
}

export interface SetRobotOnlineRequest {
  robotSerial: string;
}

export interface SetRobotOnlineResponse {
}

/**
 * SetRobotOffline is best-effort: the manager simply marks the robot's
 * rotation node stale in memory, so there is nothing for the caller to check.
 */
export interface SetRobotOfflineRequest {
  robotSerial: string;
}

export interface SetRobotOfflineResponse {
}

export interface AssignWatcherRequest {
  poolId: number;
  watcherId: string;
}

export interface AssignWatcherResponse {
}

export interface RemoveWatcherRequest {
  watcherId: string;
}

export interface RemoveWatcherResponse {
}

export interface GetWatcherAssignmentRequest {
  watcherId: string;
}

export interface GetWatcherAssignmentResponse {
  assignment: PoolAssignmentWatcher | undefined;
}

export interface ListPoolWatchersRequest {
  poolId: number;
}

export interface ListPoolWatchersResponse {
  assignments: PoolAssignmentWatcher[];
}

/**
 * Lists watcher pool assignments across all pools. An empty watcher_ids
 * filter returns every assignment; otherwise only assignments for the given
 * watcher ids are returned. Watchers not assigned to any pool are simply
 * absent from the response.
 */
export interface ListWatcherAssignmentsRequest {
  watcherIds: string[];
}

export interface ListWatcherAssignmentsResponse {
  assignments: PoolAssignmentWatcher[];
}

export interface AssignIntervenerRequest {
  poolId: number;
  intervenerId: string;
}

export interface AssignIntervenerResponse {
}

export interface RemoveIntervenerRequest {
  intervenerId: string;
}

export interface RemoveIntervenerResponse {
}

export interface GetIntervenerAssignmentRequest {
  intervenerId: string;
}

export interface GetIntervenerAssignmentResponse {
  assignment: PoolAssignmentIntervener | undefined;
}

export interface ListPoolIntervenersRequest {
  poolId: number;
}

export interface ListPoolIntervenersResponse {
  assignments: PoolAssignmentIntervener[];
}

/**
 * Lists intervener pool assignments across all pools. An empty intervener_ids
 * filter returns every assignment; otherwise only assignments for the given
 * intervener ids are returned. Interveners not assigned to any pool are simply
 * absent from the response.
 */
export interface ListIntervenerAssignmentsRequest {
  intervenerIds: string[];
}

export interface ListIntervenerAssignmentsResponse {
  assignments: PoolAssignmentIntervener[];
}

export interface RobotPair {
  robotSerial: string;
  nextRobotSerial?: string | undefined;
}

/**
 * A watcher who is clocked in explicitly, or called GetNextRobot
 * recently enough to be considered active.
 */
export interface ActiveWatcher {
  watcherId: string;
  robots: RobotPair | undefined;
  lastPull: string | undefined;
  poolId: number;
}

/** An intervener's session */
export interface ActiveIntervener {
  intervenerId: string;
  /** optional, as they may be idle */
  robotSerial?: string | undefined;
  poolId: number;
}

/** A robot currently online in its pool's rotation. */
export interface ActiveRobot {
  robotSerial: string;
  poolId: number;
}

export interface ListActiveWatchersRequest {
}

export interface ListActiveWatchersResponse {
  watchers: ActiveWatcher[];
}

export interface ListActiveIntervenersRequest {
}

export interface ListActiveIntervenersResponse {
  interveners: ActiveIntervener[];
}

export interface ListActiveRobotsRequest {
}

export interface ListActiveRobotsResponse {
  robots: ActiveRobot[];
}

export interface ClockInIntervenerRequest {
  intervenerId: string;
}

export interface ClockInIntervenerResponse {
  intervener: ActiveIntervener | undefined;
}

export interface ClockOutIntervenerRequest {
  intervenerId: string;
}

export interface ClockOutIntervenerResponse {
}

export interface ClockInWatcherRequest {
  watcherId: string;
}

export interface ClockInWatcherResponse {
  watcher: ActiveWatcher | undefined;
}

export interface ClockOutWatcherRequest {
  watcherId: string;
}

export interface ClockOutWatcherResponse {
}

export interface GetNextRobotRequest {
  watcherId: string;
}

/**
 * A watcher's first call fills both slots of the pair; every later call rotates
 * the pool once, promoting the prefetched robot to current and handing back a
 * fresh one to cache.
 */
export interface GetNextRobotResponse {
  robots: RobotPair | undefined;
}

function createBasePool(): Pool {
  return { id: 0, name: "" };
}

export const Pool: MessageFns<Pool> = {
  encode(message: Pool, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint64(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Pool {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePool();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Pool {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
    };
  },

  toJSON(message: Pool): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Pool>, I>>(base?: I): Pool {
    return Pool.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Pool>, I>>(object: I): Pool {
    const message = createBasePool();
    message.id = object.id ?? 0;
    message.name = object.name ?? "";
    return message;
  },
};

function createBasePoolAssignmentRobot(): PoolAssignmentRobot {
  return { id: 0, poolId: 0, robotSerial: "" };
}

export const PoolAssignmentRobot: MessageFns<PoolAssignmentRobot> = {
  encode(message: PoolAssignmentRobot, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint64(message.id);
    }
    if (message.poolId !== 0) {
      writer.uint32(16).uint64(message.poolId);
    }
    if (message.robotSerial !== "") {
      writer.uint32(26).string(message.robotSerial);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PoolAssignmentRobot {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePoolAssignmentRobot();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.poolId = longToNumber(reader.uint64());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.robotSerial = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PoolAssignmentRobot {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      poolId: isSet(object.poolId)
        ? globalThis.Number(object.poolId)
        : isSet(object.pool_id)
        ? globalThis.Number(object.pool_id)
        : 0,
      robotSerial: isSet(object.robotSerial)
        ? globalThis.String(object.robotSerial)
        : isSet(object.robot_serial)
        ? globalThis.String(object.robot_serial)
        : "",
    };
  },

  toJSON(message: PoolAssignmentRobot): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.poolId !== 0) {
      obj.poolId = Math.round(message.poolId);
    }
    if (message.robotSerial !== "") {
      obj.robotSerial = message.robotSerial;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PoolAssignmentRobot>, I>>(base?: I): PoolAssignmentRobot {
    return PoolAssignmentRobot.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PoolAssignmentRobot>, I>>(object: I): PoolAssignmentRobot {
    const message = createBasePoolAssignmentRobot();
    message.id = object.id ?? 0;
    message.poolId = object.poolId ?? 0;
    message.robotSerial = object.robotSerial ?? "";
    return message;
  },
};

function createBasePoolAssignmentIntervener(): PoolAssignmentIntervener {
  return { id: 0, poolId: 0, intervenerId: "" };
}

export const PoolAssignmentIntervener: MessageFns<PoolAssignmentIntervener> = {
  encode(message: PoolAssignmentIntervener, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint64(message.id);
    }
    if (message.poolId !== 0) {
      writer.uint32(16).uint64(message.poolId);
    }
    if (message.intervenerId !== "") {
      writer.uint32(26).string(message.intervenerId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PoolAssignmentIntervener {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePoolAssignmentIntervener();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.poolId = longToNumber(reader.uint64());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.intervenerId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PoolAssignmentIntervener {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      poolId: isSet(object.poolId)
        ? globalThis.Number(object.poolId)
        : isSet(object.pool_id)
        ? globalThis.Number(object.pool_id)
        : 0,
      intervenerId: isSet(object.intervenerId)
        ? globalThis.String(object.intervenerId)
        : isSet(object.intervener_id)
        ? globalThis.String(object.intervener_id)
        : "",
    };
  },

  toJSON(message: PoolAssignmentIntervener): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.poolId !== 0) {
      obj.poolId = Math.round(message.poolId);
    }
    if (message.intervenerId !== "") {
      obj.intervenerId = message.intervenerId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PoolAssignmentIntervener>, I>>(base?: I): PoolAssignmentIntervener {
    return PoolAssignmentIntervener.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PoolAssignmentIntervener>, I>>(object: I): PoolAssignmentIntervener {
    const message = createBasePoolAssignmentIntervener();
    message.id = object.id ?? 0;
    message.poolId = object.poolId ?? 0;
    message.intervenerId = object.intervenerId ?? "";
    return message;
  },
};

function createBasePoolAssignmentWatcher(): PoolAssignmentWatcher {
  return { id: 0, poolId: 0, watcherId: "" };
}

export const PoolAssignmentWatcher: MessageFns<PoolAssignmentWatcher> = {
  encode(message: PoolAssignmentWatcher, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint64(message.id);
    }
    if (message.poolId !== 0) {
      writer.uint32(16).uint64(message.poolId);
    }
    if (message.watcherId !== "") {
      writer.uint32(26).string(message.watcherId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PoolAssignmentWatcher {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePoolAssignmentWatcher();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.poolId = longToNumber(reader.uint64());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.watcherId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PoolAssignmentWatcher {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      poolId: isSet(object.poolId)
        ? globalThis.Number(object.poolId)
        : isSet(object.pool_id)
        ? globalThis.Number(object.pool_id)
        : 0,
      watcherId: isSet(object.watcherId)
        ? globalThis.String(object.watcherId)
        : isSet(object.watcher_id)
        ? globalThis.String(object.watcher_id)
        : "",
    };
  },

  toJSON(message: PoolAssignmentWatcher): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.poolId !== 0) {
      obj.poolId = Math.round(message.poolId);
    }
    if (message.watcherId !== "") {
      obj.watcherId = message.watcherId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PoolAssignmentWatcher>, I>>(base?: I): PoolAssignmentWatcher {
    return PoolAssignmentWatcher.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PoolAssignmentWatcher>, I>>(object: I): PoolAssignmentWatcher {
    const message = createBasePoolAssignmentWatcher();
    message.id = object.id ?? 0;
    message.poolId = object.poolId ?? 0;
    message.watcherId = object.watcherId ?? "";
    return message;
  },
};

function createBaseCreatePoolRequest(): CreatePoolRequest {
  return { name: "" };
}

export const CreatePoolRequest: MessageFns<CreatePoolRequest> = {
  encode(message: CreatePoolRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreatePoolRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreatePoolRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreatePoolRequest {
    return { name: isSet(object.name) ? globalThis.String(object.name) : "" };
  },

  toJSON(message: CreatePoolRequest): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreatePoolRequest>, I>>(base?: I): CreatePoolRequest {
    return CreatePoolRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreatePoolRequest>, I>>(object: I): CreatePoolRequest {
    const message = createBaseCreatePoolRequest();
    message.name = object.name ?? "";
    return message;
  },
};

function createBaseCreatePoolResponse(): CreatePoolResponse {
  return { pool: undefined };
}

export const CreatePoolResponse: MessageFns<CreatePoolResponse> = {
  encode(message: CreatePoolResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pool !== undefined) {
      Pool.encode(message.pool, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreatePoolResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreatePoolResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pool = Pool.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreatePoolResponse {
    return { pool: isSet(object.pool) ? Pool.fromJSON(object.pool) : undefined };
  },

  toJSON(message: CreatePoolResponse): unknown {
    const obj: any = {};
    if (message.pool !== undefined) {
      obj.pool = Pool.toJSON(message.pool);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreatePoolResponse>, I>>(base?: I): CreatePoolResponse {
    return CreatePoolResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreatePoolResponse>, I>>(object: I): CreatePoolResponse {
    const message = createBaseCreatePoolResponse();
    message.pool = (object.pool !== undefined && object.pool !== null) ? Pool.fromPartial(object.pool) : undefined;
    return message;
  },
};

function createBaseGetPoolRequest(): GetPoolRequest {
  return { poolId: 0 };
}

export const GetPoolRequest: MessageFns<GetPoolRequest> = {
  encode(message: GetPoolRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.poolId !== 0) {
      writer.uint32(8).uint64(message.poolId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPoolRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPoolRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.poolId = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPoolRequest {
    return {
      poolId: isSet(object.poolId)
        ? globalThis.Number(object.poolId)
        : isSet(object.pool_id)
        ? globalThis.Number(object.pool_id)
        : 0,
    };
  },

  toJSON(message: GetPoolRequest): unknown {
    const obj: any = {};
    if (message.poolId !== 0) {
      obj.poolId = Math.round(message.poolId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPoolRequest>, I>>(base?: I): GetPoolRequest {
    return GetPoolRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPoolRequest>, I>>(object: I): GetPoolRequest {
    const message = createBaseGetPoolRequest();
    message.poolId = object.poolId ?? 0;
    return message;
  },
};

function createBaseGetPoolResponse(): GetPoolResponse {
  return { pool: undefined };
}

export const GetPoolResponse: MessageFns<GetPoolResponse> = {
  encode(message: GetPoolResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pool !== undefined) {
      Pool.encode(message.pool, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPoolResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPoolResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pool = Pool.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPoolResponse {
    return { pool: isSet(object.pool) ? Pool.fromJSON(object.pool) : undefined };
  },

  toJSON(message: GetPoolResponse): unknown {
    const obj: any = {};
    if (message.pool !== undefined) {
      obj.pool = Pool.toJSON(message.pool);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPoolResponse>, I>>(base?: I): GetPoolResponse {
    return GetPoolResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPoolResponse>, I>>(object: I): GetPoolResponse {
    const message = createBaseGetPoolResponse();
    message.pool = (object.pool !== undefined && object.pool !== null) ? Pool.fromPartial(object.pool) : undefined;
    return message;
  },
};

function createBaseListWatchPoolsRequest(): ListWatchPoolsRequest {
  return {};
}

export const ListWatchPoolsRequest: MessageFns<ListWatchPoolsRequest> = {
  encode(_: ListWatchPoolsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListWatchPoolsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListWatchPoolsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ListWatchPoolsRequest {
    return {};
  },

  toJSON(_: ListWatchPoolsRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ListWatchPoolsRequest>, I>>(base?: I): ListWatchPoolsRequest {
    return ListWatchPoolsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListWatchPoolsRequest>, I>>(_: I): ListWatchPoolsRequest {
    const message = createBaseListWatchPoolsRequest();
    return message;
  },
};

function createBaseListWatchPoolsResponse(): ListWatchPoolsResponse {
  return { pageToken: "", pools: [] };
}

export const ListWatchPoolsResponse: MessageFns<ListWatchPoolsResponse> = {
  encode(message: ListWatchPoolsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pageToken !== "") {
      writer.uint32(10).string(message.pageToken);
    }
    for (const v of message.pools) {
      Pool.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListWatchPoolsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListWatchPoolsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pools.push(Pool.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListWatchPoolsResponse {
    return {
      pageToken: isSet(object.pageToken)
        ? globalThis.String(object.pageToken)
        : isSet(object.page_token)
        ? globalThis.String(object.page_token)
        : "",
      pools: globalThis.Array.isArray(object?.pools) ? object.pools.map((e: any) => Pool.fromJSON(e)) : [],
    };
  },

  toJSON(message: ListWatchPoolsResponse): unknown {
    const obj: any = {};
    if (message.pageToken !== "") {
      obj.pageToken = message.pageToken;
    }
    if (message.pools?.length) {
      obj.pools = message.pools.map((e) => Pool.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListWatchPoolsResponse>, I>>(base?: I): ListWatchPoolsResponse {
    return ListWatchPoolsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListWatchPoolsResponse>, I>>(object: I): ListWatchPoolsResponse {
    const message = createBaseListWatchPoolsResponse();
    message.pageToken = object.pageToken ?? "";
    message.pools = object.pools?.map((e) => Pool.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDeletePoolRequest(): DeletePoolRequest {
  return { poolId: 0 };
}

export const DeletePoolRequest: MessageFns<DeletePoolRequest> = {
  encode(message: DeletePoolRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.poolId !== 0) {
      writer.uint32(8).uint64(message.poolId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeletePoolRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeletePoolRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.poolId = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeletePoolRequest {
    return {
      poolId: isSet(object.poolId)
        ? globalThis.Number(object.poolId)
        : isSet(object.pool_id)
        ? globalThis.Number(object.pool_id)
        : 0,
    };
  },

  toJSON(message: DeletePoolRequest): unknown {
    const obj: any = {};
    if (message.poolId !== 0) {
      obj.poolId = Math.round(message.poolId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeletePoolRequest>, I>>(base?: I): DeletePoolRequest {
    return DeletePoolRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeletePoolRequest>, I>>(object: I): DeletePoolRequest {
    const message = createBaseDeletePoolRequest();
    message.poolId = object.poolId ?? 0;
    return message;
  },
};

function createBaseDeletePoolResponse(): DeletePoolResponse {
  return {};
}

export const DeletePoolResponse: MessageFns<DeletePoolResponse> = {
  encode(_: DeletePoolResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeletePoolResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeletePoolResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DeletePoolResponse {
    return {};
  },

  toJSON(_: DeletePoolResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<DeletePoolResponse>, I>>(base?: I): DeletePoolResponse {
    return DeletePoolResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeletePoolResponse>, I>>(_: I): DeletePoolResponse {
    const message = createBaseDeletePoolResponse();
    return message;
  },
};

function createBaseAssignRobotRequest(): AssignRobotRequest {
  return { poolId: 0, robotSerial: "" };
}

export const AssignRobotRequest: MessageFns<AssignRobotRequest> = {
  encode(message: AssignRobotRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.poolId !== 0) {
      writer.uint32(8).uint64(message.poolId);
    }
    if (message.robotSerial !== "") {
      writer.uint32(18).string(message.robotSerial);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssignRobotRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssignRobotRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.poolId = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.robotSerial = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssignRobotRequest {
    return {
      poolId: isSet(object.poolId)
        ? globalThis.Number(object.poolId)
        : isSet(object.pool_id)
        ? globalThis.Number(object.pool_id)
        : 0,
      robotSerial: isSet(object.robotSerial)
        ? globalThis.String(object.robotSerial)
        : isSet(object.robot_serial)
        ? globalThis.String(object.robot_serial)
        : "",
    };
  },

  toJSON(message: AssignRobotRequest): unknown {
    const obj: any = {};
    if (message.poolId !== 0) {
      obj.poolId = Math.round(message.poolId);
    }
    if (message.robotSerial !== "") {
      obj.robotSerial = message.robotSerial;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssignRobotRequest>, I>>(base?: I): AssignRobotRequest {
    return AssignRobotRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssignRobotRequest>, I>>(object: I): AssignRobotRequest {
    const message = createBaseAssignRobotRequest();
    message.poolId = object.poolId ?? 0;
    message.robotSerial = object.robotSerial ?? "";
    return message;
  },
};

function createBaseAssignRobotResponse(): AssignRobotResponse {
  return {};
}

export const AssignRobotResponse: MessageFns<AssignRobotResponse> = {
  encode(_: AssignRobotResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssignRobotResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssignRobotResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): AssignRobotResponse {
    return {};
  },

  toJSON(_: AssignRobotResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<AssignRobotResponse>, I>>(base?: I): AssignRobotResponse {
    return AssignRobotResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssignRobotResponse>, I>>(_: I): AssignRobotResponse {
    const message = createBaseAssignRobotResponse();
    return message;
  },
};

function createBaseUnassignRobotRequest(): UnassignRobotRequest {
  return { robotSerial: "" };
}

export const UnassignRobotRequest: MessageFns<UnassignRobotRequest> = {
  encode(message: UnassignRobotRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.robotSerial !== "") {
      writer.uint32(10).string(message.robotSerial);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UnassignRobotRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnassignRobotRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.robotSerial = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UnassignRobotRequest {
    return {
      robotSerial: isSet(object.robotSerial)
        ? globalThis.String(object.robotSerial)
        : isSet(object.robot_serial)
        ? globalThis.String(object.robot_serial)
        : "",
    };
  },

  toJSON(message: UnassignRobotRequest): unknown {
    const obj: any = {};
    if (message.robotSerial !== "") {
      obj.robotSerial = message.robotSerial;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UnassignRobotRequest>, I>>(base?: I): UnassignRobotRequest {
    return UnassignRobotRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UnassignRobotRequest>, I>>(object: I): UnassignRobotRequest {
    const message = createBaseUnassignRobotRequest();
    message.robotSerial = object.robotSerial ?? "";
    return message;
  },
};

function createBaseUnassignRobotResponse(): UnassignRobotResponse {
  return {};
}

export const UnassignRobotResponse: MessageFns<UnassignRobotResponse> = {
  encode(_: UnassignRobotResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UnassignRobotResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnassignRobotResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): UnassignRobotResponse {
    return {};
  },

  toJSON(_: UnassignRobotResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<UnassignRobotResponse>, I>>(base?: I): UnassignRobotResponse {
    return UnassignRobotResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UnassignRobotResponse>, I>>(_: I): UnassignRobotResponse {
    const message = createBaseUnassignRobotResponse();
    return message;
  },
};

function createBaseGetRobotAssignmentRequest(): GetRobotAssignmentRequest {
  return { robotSerial: "" };
}

export const GetRobotAssignmentRequest: MessageFns<GetRobotAssignmentRequest> = {
  encode(message: GetRobotAssignmentRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.robotSerial !== "") {
      writer.uint32(10).string(message.robotSerial);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRobotAssignmentRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRobotAssignmentRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.robotSerial = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetRobotAssignmentRequest {
    return {
      robotSerial: isSet(object.robotSerial)
        ? globalThis.String(object.robotSerial)
        : isSet(object.robot_serial)
        ? globalThis.String(object.robot_serial)
        : "",
    };
  },

  toJSON(message: GetRobotAssignmentRequest): unknown {
    const obj: any = {};
    if (message.robotSerial !== "") {
      obj.robotSerial = message.robotSerial;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetRobotAssignmentRequest>, I>>(base?: I): GetRobotAssignmentRequest {
    return GetRobotAssignmentRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetRobotAssignmentRequest>, I>>(object: I): GetRobotAssignmentRequest {
    const message = createBaseGetRobotAssignmentRequest();
    message.robotSerial = object.robotSerial ?? "";
    return message;
  },
};

function createBaseGetRobotAssignmentResponse(): GetRobotAssignmentResponse {
  return { assignment: undefined };
}

export const GetRobotAssignmentResponse: MessageFns<GetRobotAssignmentResponse> = {
  encode(message: GetRobotAssignmentResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.assignment !== undefined) {
      PoolAssignmentRobot.encode(message.assignment, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRobotAssignmentResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRobotAssignmentResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.assignment = PoolAssignmentRobot.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetRobotAssignmentResponse {
    return { assignment: isSet(object.assignment) ? PoolAssignmentRobot.fromJSON(object.assignment) : undefined };
  },

  toJSON(message: GetRobotAssignmentResponse): unknown {
    const obj: any = {};
    if (message.assignment !== undefined) {
      obj.assignment = PoolAssignmentRobot.toJSON(message.assignment);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetRobotAssignmentResponse>, I>>(base?: I): GetRobotAssignmentResponse {
    return GetRobotAssignmentResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetRobotAssignmentResponse>, I>>(object: I): GetRobotAssignmentResponse {
    const message = createBaseGetRobotAssignmentResponse();
    message.assignment = (object.assignment !== undefined && object.assignment !== null)
      ? PoolAssignmentRobot.fromPartial(object.assignment)
      : undefined;
    return message;
  },
};

function createBaseListPoolRobotsRequest(): ListPoolRobotsRequest {
  return { poolId: 0 };
}

export const ListPoolRobotsRequest: MessageFns<ListPoolRobotsRequest> = {
  encode(message: ListPoolRobotsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.poolId !== 0) {
      writer.uint32(8).uint64(message.poolId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListPoolRobotsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListPoolRobotsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.poolId = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListPoolRobotsRequest {
    return {
      poolId: isSet(object.poolId)
        ? globalThis.Number(object.poolId)
        : isSet(object.pool_id)
        ? globalThis.Number(object.pool_id)
        : 0,
    };
  },

  toJSON(message: ListPoolRobotsRequest): unknown {
    const obj: any = {};
    if (message.poolId !== 0) {
      obj.poolId = Math.round(message.poolId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListPoolRobotsRequest>, I>>(base?: I): ListPoolRobotsRequest {
    return ListPoolRobotsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListPoolRobotsRequest>, I>>(object: I): ListPoolRobotsRequest {
    const message = createBaseListPoolRobotsRequest();
    message.poolId = object.poolId ?? 0;
    return message;
  },
};

function createBaseListPoolRobotsResponse(): ListPoolRobotsResponse {
  return { assignments: [] };
}

export const ListPoolRobotsResponse: MessageFns<ListPoolRobotsResponse> = {
  encode(message: ListPoolRobotsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.assignments) {
      PoolAssignmentRobot.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListPoolRobotsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListPoolRobotsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.assignments.push(PoolAssignmentRobot.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListPoolRobotsResponse {
    return {
      assignments: globalThis.Array.isArray(object?.assignments)
        ? object.assignments.map((e: any) => PoolAssignmentRobot.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListPoolRobotsResponse): unknown {
    const obj: any = {};
    if (message.assignments?.length) {
      obj.assignments = message.assignments.map((e) => PoolAssignmentRobot.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListPoolRobotsResponse>, I>>(base?: I): ListPoolRobotsResponse {
    return ListPoolRobotsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListPoolRobotsResponse>, I>>(object: I): ListPoolRobotsResponse {
    const message = createBaseListPoolRobotsResponse();
    message.assignments = object.assignments?.map((e) => PoolAssignmentRobot.fromPartial(e)) || [];
    return message;
  },
};

function createBaseListRobotAssignmentsRequest(): ListRobotAssignmentsRequest {
  return { robotSerials: [] };
}

export const ListRobotAssignmentsRequest: MessageFns<ListRobotAssignmentsRequest> = {
  encode(message: ListRobotAssignmentsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.robotSerials) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListRobotAssignmentsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListRobotAssignmentsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.robotSerials.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListRobotAssignmentsRequest {
    return {
      robotSerials: globalThis.Array.isArray(object?.robotSerials)
        ? object.robotSerials.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.robot_serials)
        ? object.robot_serials.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ListRobotAssignmentsRequest): unknown {
    const obj: any = {};
    if (message.robotSerials?.length) {
      obj.robotSerials = message.robotSerials;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListRobotAssignmentsRequest>, I>>(base?: I): ListRobotAssignmentsRequest {
    return ListRobotAssignmentsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListRobotAssignmentsRequest>, I>>(object: I): ListRobotAssignmentsRequest {
    const message = createBaseListRobotAssignmentsRequest();
    message.robotSerials = object.robotSerials?.map((e) => e) || [];
    return message;
  },
};

function createBaseListRobotAssignmentsResponse(): ListRobotAssignmentsResponse {
  return { assignments: [] };
}

export const ListRobotAssignmentsResponse: MessageFns<ListRobotAssignmentsResponse> = {
  encode(message: ListRobotAssignmentsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.assignments) {
      PoolAssignmentRobot.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListRobotAssignmentsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListRobotAssignmentsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.assignments.push(PoolAssignmentRobot.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListRobotAssignmentsResponse {
    return {
      assignments: globalThis.Array.isArray(object?.assignments)
        ? object.assignments.map((e: any) => PoolAssignmentRobot.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListRobotAssignmentsResponse): unknown {
    const obj: any = {};
    if (message.assignments?.length) {
      obj.assignments = message.assignments.map((e) => PoolAssignmentRobot.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListRobotAssignmentsResponse>, I>>(base?: I): ListRobotAssignmentsResponse {
    return ListRobotAssignmentsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListRobotAssignmentsResponse>, I>>(object: I): ListRobotAssignmentsResponse {
    const message = createBaseListRobotAssignmentsResponse();
    message.assignments = object.assignments?.map((e) => PoolAssignmentRobot.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSetRobotOnlineRequest(): SetRobotOnlineRequest {
  return { robotSerial: "" };
}

export const SetRobotOnlineRequest: MessageFns<SetRobotOnlineRequest> = {
  encode(message: SetRobotOnlineRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.robotSerial !== "") {
      writer.uint32(10).string(message.robotSerial);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetRobotOnlineRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetRobotOnlineRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.robotSerial = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetRobotOnlineRequest {
    return {
      robotSerial: isSet(object.robotSerial)
        ? globalThis.String(object.robotSerial)
        : isSet(object.robot_serial)
        ? globalThis.String(object.robot_serial)
        : "",
    };
  },

  toJSON(message: SetRobotOnlineRequest): unknown {
    const obj: any = {};
    if (message.robotSerial !== "") {
      obj.robotSerial = message.robotSerial;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetRobotOnlineRequest>, I>>(base?: I): SetRobotOnlineRequest {
    return SetRobotOnlineRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetRobotOnlineRequest>, I>>(object: I): SetRobotOnlineRequest {
    const message = createBaseSetRobotOnlineRequest();
    message.robotSerial = object.robotSerial ?? "";
    return message;
  },
};

function createBaseSetRobotOnlineResponse(): SetRobotOnlineResponse {
  return {};
}

export const SetRobotOnlineResponse: MessageFns<SetRobotOnlineResponse> = {
  encode(_: SetRobotOnlineResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetRobotOnlineResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetRobotOnlineResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SetRobotOnlineResponse {
    return {};
  },

  toJSON(_: SetRobotOnlineResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SetRobotOnlineResponse>, I>>(base?: I): SetRobotOnlineResponse {
    return SetRobotOnlineResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetRobotOnlineResponse>, I>>(_: I): SetRobotOnlineResponse {
    const message = createBaseSetRobotOnlineResponse();
    return message;
  },
};

function createBaseSetRobotOfflineRequest(): SetRobotOfflineRequest {
  return { robotSerial: "" };
}

export const SetRobotOfflineRequest: MessageFns<SetRobotOfflineRequest> = {
  encode(message: SetRobotOfflineRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.robotSerial !== "") {
      writer.uint32(10).string(message.robotSerial);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetRobotOfflineRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetRobotOfflineRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.robotSerial = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetRobotOfflineRequest {
    return {
      robotSerial: isSet(object.robotSerial)
        ? globalThis.String(object.robotSerial)
        : isSet(object.robot_serial)
        ? globalThis.String(object.robot_serial)
        : "",
    };
  },

  toJSON(message: SetRobotOfflineRequest): unknown {
    const obj: any = {};
    if (message.robotSerial !== "") {
      obj.robotSerial = message.robotSerial;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetRobotOfflineRequest>, I>>(base?: I): SetRobotOfflineRequest {
    return SetRobotOfflineRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetRobotOfflineRequest>, I>>(object: I): SetRobotOfflineRequest {
    const message = createBaseSetRobotOfflineRequest();
    message.robotSerial = object.robotSerial ?? "";
    return message;
  },
};

function createBaseSetRobotOfflineResponse(): SetRobotOfflineResponse {
  return {};
}

export const SetRobotOfflineResponse: MessageFns<SetRobotOfflineResponse> = {
  encode(_: SetRobotOfflineResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetRobotOfflineResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetRobotOfflineResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SetRobotOfflineResponse {
    return {};
  },

  toJSON(_: SetRobotOfflineResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SetRobotOfflineResponse>, I>>(base?: I): SetRobotOfflineResponse {
    return SetRobotOfflineResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetRobotOfflineResponse>, I>>(_: I): SetRobotOfflineResponse {
    const message = createBaseSetRobotOfflineResponse();
    return message;
  },
};

function createBaseAssignWatcherRequest(): AssignWatcherRequest {
  return { poolId: 0, watcherId: "" };
}

export const AssignWatcherRequest: MessageFns<AssignWatcherRequest> = {
  encode(message: AssignWatcherRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.poolId !== 0) {
      writer.uint32(8).uint64(message.poolId);
    }
    if (message.watcherId !== "") {
      writer.uint32(18).string(message.watcherId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssignWatcherRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssignWatcherRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.poolId = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.watcherId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssignWatcherRequest {
    return {
      poolId: isSet(object.poolId)
        ? globalThis.Number(object.poolId)
        : isSet(object.pool_id)
        ? globalThis.Number(object.pool_id)
        : 0,
      watcherId: isSet(object.watcherId)
        ? globalThis.String(object.watcherId)
        : isSet(object.watcher_id)
        ? globalThis.String(object.watcher_id)
        : "",
    };
  },

  toJSON(message: AssignWatcherRequest): unknown {
    const obj: any = {};
    if (message.poolId !== 0) {
      obj.poolId = Math.round(message.poolId);
    }
    if (message.watcherId !== "") {
      obj.watcherId = message.watcherId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssignWatcherRequest>, I>>(base?: I): AssignWatcherRequest {
    return AssignWatcherRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssignWatcherRequest>, I>>(object: I): AssignWatcherRequest {
    const message = createBaseAssignWatcherRequest();
    message.poolId = object.poolId ?? 0;
    message.watcherId = object.watcherId ?? "";
    return message;
  },
};

function createBaseAssignWatcherResponse(): AssignWatcherResponse {
  return {};
}

export const AssignWatcherResponse: MessageFns<AssignWatcherResponse> = {
  encode(_: AssignWatcherResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssignWatcherResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssignWatcherResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): AssignWatcherResponse {
    return {};
  },

  toJSON(_: AssignWatcherResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<AssignWatcherResponse>, I>>(base?: I): AssignWatcherResponse {
    return AssignWatcherResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssignWatcherResponse>, I>>(_: I): AssignWatcherResponse {
    const message = createBaseAssignWatcherResponse();
    return message;
  },
};

function createBaseRemoveWatcherRequest(): RemoveWatcherRequest {
  return { watcherId: "" };
}

export const RemoveWatcherRequest: MessageFns<RemoveWatcherRequest> = {
  encode(message: RemoveWatcherRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.watcherId !== "") {
      writer.uint32(10).string(message.watcherId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveWatcherRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveWatcherRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.watcherId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveWatcherRequest {
    return {
      watcherId: isSet(object.watcherId)
        ? globalThis.String(object.watcherId)
        : isSet(object.watcher_id)
        ? globalThis.String(object.watcher_id)
        : "",
    };
  },

  toJSON(message: RemoveWatcherRequest): unknown {
    const obj: any = {};
    if (message.watcherId !== "") {
      obj.watcherId = message.watcherId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RemoveWatcherRequest>, I>>(base?: I): RemoveWatcherRequest {
    return RemoveWatcherRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoveWatcherRequest>, I>>(object: I): RemoveWatcherRequest {
    const message = createBaseRemoveWatcherRequest();
    message.watcherId = object.watcherId ?? "";
    return message;
  },
};

function createBaseRemoveWatcherResponse(): RemoveWatcherResponse {
  return {};
}

export const RemoveWatcherResponse: MessageFns<RemoveWatcherResponse> = {
  encode(_: RemoveWatcherResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveWatcherResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveWatcherResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RemoveWatcherResponse {
    return {};
  },

  toJSON(_: RemoveWatcherResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<RemoveWatcherResponse>, I>>(base?: I): RemoveWatcherResponse {
    return RemoveWatcherResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoveWatcherResponse>, I>>(_: I): RemoveWatcherResponse {
    const message = createBaseRemoveWatcherResponse();
    return message;
  },
};

function createBaseGetWatcherAssignmentRequest(): GetWatcherAssignmentRequest {
  return { watcherId: "" };
}

export const GetWatcherAssignmentRequest: MessageFns<GetWatcherAssignmentRequest> = {
  encode(message: GetWatcherAssignmentRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.watcherId !== "") {
      writer.uint32(10).string(message.watcherId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetWatcherAssignmentRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetWatcherAssignmentRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.watcherId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetWatcherAssignmentRequest {
    return {
      watcherId: isSet(object.watcherId)
        ? globalThis.String(object.watcherId)
        : isSet(object.watcher_id)
        ? globalThis.String(object.watcher_id)
        : "",
    };
  },

  toJSON(message: GetWatcherAssignmentRequest): unknown {
    const obj: any = {};
    if (message.watcherId !== "") {
      obj.watcherId = message.watcherId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetWatcherAssignmentRequest>, I>>(base?: I): GetWatcherAssignmentRequest {
    return GetWatcherAssignmentRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetWatcherAssignmentRequest>, I>>(object: I): GetWatcherAssignmentRequest {
    const message = createBaseGetWatcherAssignmentRequest();
    message.watcherId = object.watcherId ?? "";
    return message;
  },
};

function createBaseGetWatcherAssignmentResponse(): GetWatcherAssignmentResponse {
  return { assignment: undefined };
}

export const GetWatcherAssignmentResponse: MessageFns<GetWatcherAssignmentResponse> = {
  encode(message: GetWatcherAssignmentResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.assignment !== undefined) {
      PoolAssignmentWatcher.encode(message.assignment, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetWatcherAssignmentResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetWatcherAssignmentResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.assignment = PoolAssignmentWatcher.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetWatcherAssignmentResponse {
    return { assignment: isSet(object.assignment) ? PoolAssignmentWatcher.fromJSON(object.assignment) : undefined };
  },

  toJSON(message: GetWatcherAssignmentResponse): unknown {
    const obj: any = {};
    if (message.assignment !== undefined) {
      obj.assignment = PoolAssignmentWatcher.toJSON(message.assignment);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetWatcherAssignmentResponse>, I>>(base?: I): GetWatcherAssignmentResponse {
    return GetWatcherAssignmentResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetWatcherAssignmentResponse>, I>>(object: I): GetWatcherAssignmentResponse {
    const message = createBaseGetWatcherAssignmentResponse();
    message.assignment = (object.assignment !== undefined && object.assignment !== null)
      ? PoolAssignmentWatcher.fromPartial(object.assignment)
      : undefined;
    return message;
  },
};

function createBaseListPoolWatchersRequest(): ListPoolWatchersRequest {
  return { poolId: 0 };
}

export const ListPoolWatchersRequest: MessageFns<ListPoolWatchersRequest> = {
  encode(message: ListPoolWatchersRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.poolId !== 0) {
      writer.uint32(8).uint64(message.poolId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListPoolWatchersRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListPoolWatchersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.poolId = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListPoolWatchersRequest {
    return {
      poolId: isSet(object.poolId)
        ? globalThis.Number(object.poolId)
        : isSet(object.pool_id)
        ? globalThis.Number(object.pool_id)
        : 0,
    };
  },

  toJSON(message: ListPoolWatchersRequest): unknown {
    const obj: any = {};
    if (message.poolId !== 0) {
      obj.poolId = Math.round(message.poolId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListPoolWatchersRequest>, I>>(base?: I): ListPoolWatchersRequest {
    return ListPoolWatchersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListPoolWatchersRequest>, I>>(object: I): ListPoolWatchersRequest {
    const message = createBaseListPoolWatchersRequest();
    message.poolId = object.poolId ?? 0;
    return message;
  },
};

function createBaseListPoolWatchersResponse(): ListPoolWatchersResponse {
  return { assignments: [] };
}

export const ListPoolWatchersResponse: MessageFns<ListPoolWatchersResponse> = {
  encode(message: ListPoolWatchersResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.assignments) {
      PoolAssignmentWatcher.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListPoolWatchersResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListPoolWatchersResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.assignments.push(PoolAssignmentWatcher.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListPoolWatchersResponse {
    return {
      assignments: globalThis.Array.isArray(object?.assignments)
        ? object.assignments.map((e: any) => PoolAssignmentWatcher.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListPoolWatchersResponse): unknown {
    const obj: any = {};
    if (message.assignments?.length) {
      obj.assignments = message.assignments.map((e) => PoolAssignmentWatcher.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListPoolWatchersResponse>, I>>(base?: I): ListPoolWatchersResponse {
    return ListPoolWatchersResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListPoolWatchersResponse>, I>>(object: I): ListPoolWatchersResponse {
    const message = createBaseListPoolWatchersResponse();
    message.assignments = object.assignments?.map((e) => PoolAssignmentWatcher.fromPartial(e)) || [];
    return message;
  },
};

function createBaseListWatcherAssignmentsRequest(): ListWatcherAssignmentsRequest {
  return { watcherIds: [] };
}

export const ListWatcherAssignmentsRequest: MessageFns<ListWatcherAssignmentsRequest> = {
  encode(message: ListWatcherAssignmentsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.watcherIds) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListWatcherAssignmentsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListWatcherAssignmentsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.watcherIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListWatcherAssignmentsRequest {
    return {
      watcherIds: globalThis.Array.isArray(object?.watcherIds)
        ? object.watcherIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.watcher_ids)
        ? object.watcher_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ListWatcherAssignmentsRequest): unknown {
    const obj: any = {};
    if (message.watcherIds?.length) {
      obj.watcherIds = message.watcherIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListWatcherAssignmentsRequest>, I>>(base?: I): ListWatcherAssignmentsRequest {
    return ListWatcherAssignmentsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListWatcherAssignmentsRequest>, I>>(
    object: I,
  ): ListWatcherAssignmentsRequest {
    const message = createBaseListWatcherAssignmentsRequest();
    message.watcherIds = object.watcherIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseListWatcherAssignmentsResponse(): ListWatcherAssignmentsResponse {
  return { assignments: [] };
}

export const ListWatcherAssignmentsResponse: MessageFns<ListWatcherAssignmentsResponse> = {
  encode(message: ListWatcherAssignmentsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.assignments) {
      PoolAssignmentWatcher.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListWatcherAssignmentsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListWatcherAssignmentsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.assignments.push(PoolAssignmentWatcher.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListWatcherAssignmentsResponse {
    return {
      assignments: globalThis.Array.isArray(object?.assignments)
        ? object.assignments.map((e: any) => PoolAssignmentWatcher.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListWatcherAssignmentsResponse): unknown {
    const obj: any = {};
    if (message.assignments?.length) {
      obj.assignments = message.assignments.map((e) => PoolAssignmentWatcher.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListWatcherAssignmentsResponse>, I>>(base?: I): ListWatcherAssignmentsResponse {
    return ListWatcherAssignmentsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListWatcherAssignmentsResponse>, I>>(
    object: I,
  ): ListWatcherAssignmentsResponse {
    const message = createBaseListWatcherAssignmentsResponse();
    message.assignments = object.assignments?.map((e) => PoolAssignmentWatcher.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAssignIntervenerRequest(): AssignIntervenerRequest {
  return { poolId: 0, intervenerId: "" };
}

export const AssignIntervenerRequest: MessageFns<AssignIntervenerRequest> = {
  encode(message: AssignIntervenerRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.poolId !== 0) {
      writer.uint32(8).uint64(message.poolId);
    }
    if (message.intervenerId !== "") {
      writer.uint32(18).string(message.intervenerId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssignIntervenerRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssignIntervenerRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.poolId = longToNumber(reader.uint64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.intervenerId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssignIntervenerRequest {
    return {
      poolId: isSet(object.poolId)
        ? globalThis.Number(object.poolId)
        : isSet(object.pool_id)
        ? globalThis.Number(object.pool_id)
        : 0,
      intervenerId: isSet(object.intervenerId)
        ? globalThis.String(object.intervenerId)
        : isSet(object.intervener_id)
        ? globalThis.String(object.intervener_id)
        : "",
    };
  },

  toJSON(message: AssignIntervenerRequest): unknown {
    const obj: any = {};
    if (message.poolId !== 0) {
      obj.poolId = Math.round(message.poolId);
    }
    if (message.intervenerId !== "") {
      obj.intervenerId = message.intervenerId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssignIntervenerRequest>, I>>(base?: I): AssignIntervenerRequest {
    return AssignIntervenerRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssignIntervenerRequest>, I>>(object: I): AssignIntervenerRequest {
    const message = createBaseAssignIntervenerRequest();
    message.poolId = object.poolId ?? 0;
    message.intervenerId = object.intervenerId ?? "";
    return message;
  },
};

function createBaseAssignIntervenerResponse(): AssignIntervenerResponse {
  return {};
}

export const AssignIntervenerResponse: MessageFns<AssignIntervenerResponse> = {
  encode(_: AssignIntervenerResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssignIntervenerResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssignIntervenerResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): AssignIntervenerResponse {
    return {};
  },

  toJSON(_: AssignIntervenerResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<AssignIntervenerResponse>, I>>(base?: I): AssignIntervenerResponse {
    return AssignIntervenerResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssignIntervenerResponse>, I>>(_: I): AssignIntervenerResponse {
    const message = createBaseAssignIntervenerResponse();
    return message;
  },
};

function createBaseRemoveIntervenerRequest(): RemoveIntervenerRequest {
  return { intervenerId: "" };
}

export const RemoveIntervenerRequest: MessageFns<RemoveIntervenerRequest> = {
  encode(message: RemoveIntervenerRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.intervenerId !== "") {
      writer.uint32(10).string(message.intervenerId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveIntervenerRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveIntervenerRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.intervenerId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveIntervenerRequest {
    return {
      intervenerId: isSet(object.intervenerId)
        ? globalThis.String(object.intervenerId)
        : isSet(object.intervener_id)
        ? globalThis.String(object.intervener_id)
        : "",
    };
  },

  toJSON(message: RemoveIntervenerRequest): unknown {
    const obj: any = {};
    if (message.intervenerId !== "") {
      obj.intervenerId = message.intervenerId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RemoveIntervenerRequest>, I>>(base?: I): RemoveIntervenerRequest {
    return RemoveIntervenerRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoveIntervenerRequest>, I>>(object: I): RemoveIntervenerRequest {
    const message = createBaseRemoveIntervenerRequest();
    message.intervenerId = object.intervenerId ?? "";
    return message;
  },
};

function createBaseRemoveIntervenerResponse(): RemoveIntervenerResponse {
  return {};
}

export const RemoveIntervenerResponse: MessageFns<RemoveIntervenerResponse> = {
  encode(_: RemoveIntervenerResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveIntervenerResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveIntervenerResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RemoveIntervenerResponse {
    return {};
  },

  toJSON(_: RemoveIntervenerResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<RemoveIntervenerResponse>, I>>(base?: I): RemoveIntervenerResponse {
    return RemoveIntervenerResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoveIntervenerResponse>, I>>(_: I): RemoveIntervenerResponse {
    const message = createBaseRemoveIntervenerResponse();
    return message;
  },
};

function createBaseGetIntervenerAssignmentRequest(): GetIntervenerAssignmentRequest {
  return { intervenerId: "" };
}

export const GetIntervenerAssignmentRequest: MessageFns<GetIntervenerAssignmentRequest> = {
  encode(message: GetIntervenerAssignmentRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.intervenerId !== "") {
      writer.uint32(10).string(message.intervenerId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetIntervenerAssignmentRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetIntervenerAssignmentRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.intervenerId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetIntervenerAssignmentRequest {
    return {
      intervenerId: isSet(object.intervenerId)
        ? globalThis.String(object.intervenerId)
        : isSet(object.intervener_id)
        ? globalThis.String(object.intervener_id)
        : "",
    };
  },

  toJSON(message: GetIntervenerAssignmentRequest): unknown {
    const obj: any = {};
    if (message.intervenerId !== "") {
      obj.intervenerId = message.intervenerId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetIntervenerAssignmentRequest>, I>>(base?: I): GetIntervenerAssignmentRequest {
    return GetIntervenerAssignmentRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetIntervenerAssignmentRequest>, I>>(
    object: I,
  ): GetIntervenerAssignmentRequest {
    const message = createBaseGetIntervenerAssignmentRequest();
    message.intervenerId = object.intervenerId ?? "";
    return message;
  },
};

function createBaseGetIntervenerAssignmentResponse(): GetIntervenerAssignmentResponse {
  return { assignment: undefined };
}

export const GetIntervenerAssignmentResponse: MessageFns<GetIntervenerAssignmentResponse> = {
  encode(message: GetIntervenerAssignmentResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.assignment !== undefined) {
      PoolAssignmentIntervener.encode(message.assignment, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetIntervenerAssignmentResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetIntervenerAssignmentResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.assignment = PoolAssignmentIntervener.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetIntervenerAssignmentResponse {
    return { assignment: isSet(object.assignment) ? PoolAssignmentIntervener.fromJSON(object.assignment) : undefined };
  },

  toJSON(message: GetIntervenerAssignmentResponse): unknown {
    const obj: any = {};
    if (message.assignment !== undefined) {
      obj.assignment = PoolAssignmentIntervener.toJSON(message.assignment);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetIntervenerAssignmentResponse>, I>>(base?: I): GetIntervenerAssignmentResponse {
    return GetIntervenerAssignmentResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetIntervenerAssignmentResponse>, I>>(
    object: I,
  ): GetIntervenerAssignmentResponse {
    const message = createBaseGetIntervenerAssignmentResponse();
    message.assignment = (object.assignment !== undefined && object.assignment !== null)
      ? PoolAssignmentIntervener.fromPartial(object.assignment)
      : undefined;
    return message;
  },
};

function createBaseListPoolIntervenersRequest(): ListPoolIntervenersRequest {
  return { poolId: 0 };
}

export const ListPoolIntervenersRequest: MessageFns<ListPoolIntervenersRequest> = {
  encode(message: ListPoolIntervenersRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.poolId !== 0) {
      writer.uint32(8).uint64(message.poolId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListPoolIntervenersRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListPoolIntervenersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.poolId = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListPoolIntervenersRequest {
    return {
      poolId: isSet(object.poolId)
        ? globalThis.Number(object.poolId)
        : isSet(object.pool_id)
        ? globalThis.Number(object.pool_id)
        : 0,
    };
  },

  toJSON(message: ListPoolIntervenersRequest): unknown {
    const obj: any = {};
    if (message.poolId !== 0) {
      obj.poolId = Math.round(message.poolId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListPoolIntervenersRequest>, I>>(base?: I): ListPoolIntervenersRequest {
    return ListPoolIntervenersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListPoolIntervenersRequest>, I>>(object: I): ListPoolIntervenersRequest {
    const message = createBaseListPoolIntervenersRequest();
    message.poolId = object.poolId ?? 0;
    return message;
  },
};

function createBaseListPoolIntervenersResponse(): ListPoolIntervenersResponse {
  return { assignments: [] };
}

export const ListPoolIntervenersResponse: MessageFns<ListPoolIntervenersResponse> = {
  encode(message: ListPoolIntervenersResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.assignments) {
      PoolAssignmentIntervener.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListPoolIntervenersResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListPoolIntervenersResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.assignments.push(PoolAssignmentIntervener.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListPoolIntervenersResponse {
    return {
      assignments: globalThis.Array.isArray(object?.assignments)
        ? object.assignments.map((e: any) => PoolAssignmentIntervener.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListPoolIntervenersResponse): unknown {
    const obj: any = {};
    if (message.assignments?.length) {
      obj.assignments = message.assignments.map((e) => PoolAssignmentIntervener.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListPoolIntervenersResponse>, I>>(base?: I): ListPoolIntervenersResponse {
    return ListPoolIntervenersResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListPoolIntervenersResponse>, I>>(object: I): ListPoolIntervenersResponse {
    const message = createBaseListPoolIntervenersResponse();
    message.assignments = object.assignments?.map((e) => PoolAssignmentIntervener.fromPartial(e)) || [];
    return message;
  },
};

function createBaseListIntervenerAssignmentsRequest(): ListIntervenerAssignmentsRequest {
  return { intervenerIds: [] };
}

export const ListIntervenerAssignmentsRequest: MessageFns<ListIntervenerAssignmentsRequest> = {
  encode(message: ListIntervenerAssignmentsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.intervenerIds) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListIntervenerAssignmentsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListIntervenerAssignmentsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.intervenerIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListIntervenerAssignmentsRequest {
    return {
      intervenerIds: globalThis.Array.isArray(object?.intervenerIds)
        ? object.intervenerIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.intervener_ids)
        ? object.intervener_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ListIntervenerAssignmentsRequest): unknown {
    const obj: any = {};
    if (message.intervenerIds?.length) {
      obj.intervenerIds = message.intervenerIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListIntervenerAssignmentsRequest>, I>>(
    base?: I,
  ): ListIntervenerAssignmentsRequest {
    return ListIntervenerAssignmentsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListIntervenerAssignmentsRequest>, I>>(
    object: I,
  ): ListIntervenerAssignmentsRequest {
    const message = createBaseListIntervenerAssignmentsRequest();
    message.intervenerIds = object.intervenerIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseListIntervenerAssignmentsResponse(): ListIntervenerAssignmentsResponse {
  return { assignments: [] };
}

export const ListIntervenerAssignmentsResponse: MessageFns<ListIntervenerAssignmentsResponse> = {
  encode(message: ListIntervenerAssignmentsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.assignments) {
      PoolAssignmentIntervener.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListIntervenerAssignmentsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListIntervenerAssignmentsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.assignments.push(PoolAssignmentIntervener.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListIntervenerAssignmentsResponse {
    return {
      assignments: globalThis.Array.isArray(object?.assignments)
        ? object.assignments.map((e: any) => PoolAssignmentIntervener.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListIntervenerAssignmentsResponse): unknown {
    const obj: any = {};
    if (message.assignments?.length) {
      obj.assignments = message.assignments.map((e) => PoolAssignmentIntervener.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListIntervenerAssignmentsResponse>, I>>(
    base?: I,
  ): ListIntervenerAssignmentsResponse {
    return ListIntervenerAssignmentsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListIntervenerAssignmentsResponse>, I>>(
    object: I,
  ): ListIntervenerAssignmentsResponse {
    const message = createBaseListIntervenerAssignmentsResponse();
    message.assignments = object.assignments?.map((e) => PoolAssignmentIntervener.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRobotPair(): RobotPair {
  return { robotSerial: "", nextRobotSerial: undefined };
}

export const RobotPair: MessageFns<RobotPair> = {
  encode(message: RobotPair, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.robotSerial !== "") {
      writer.uint32(10).string(message.robotSerial);
    }
    if (message.nextRobotSerial !== undefined) {
      writer.uint32(18).string(message.nextRobotSerial);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RobotPair {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRobotPair();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.robotSerial = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nextRobotSerial = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RobotPair {
    return {
      robotSerial: isSet(object.robotSerial)
        ? globalThis.String(object.robotSerial)
        : isSet(object.robot_serial)
        ? globalThis.String(object.robot_serial)
        : "",
      nextRobotSerial: isSet(object.nextRobotSerial)
        ? globalThis.String(object.nextRobotSerial)
        : isSet(object.next_robot_serial)
        ? globalThis.String(object.next_robot_serial)
        : undefined,
    };
  },

  toJSON(message: RobotPair): unknown {
    const obj: any = {};
    if (message.robotSerial !== "") {
      obj.robotSerial = message.robotSerial;
    }
    if (message.nextRobotSerial !== undefined) {
      obj.nextRobotSerial = message.nextRobotSerial;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RobotPair>, I>>(base?: I): RobotPair {
    return RobotPair.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RobotPair>, I>>(object: I): RobotPair {
    const message = createBaseRobotPair();
    message.robotSerial = object.robotSerial ?? "";
    message.nextRobotSerial = object.nextRobotSerial ?? undefined;
    return message;
  },
};

function createBaseActiveWatcher(): ActiveWatcher {
  return { watcherId: "", robots: undefined, lastPull: undefined, poolId: 0 };
}

export const ActiveWatcher: MessageFns<ActiveWatcher> = {
  encode(message: ActiveWatcher, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.watcherId !== "") {
      writer.uint32(10).string(message.watcherId);
    }
    if (message.robots !== undefined) {
      RobotPair.encode(message.robots, writer.uint32(18).fork()).join();
    }
    if (message.lastPull !== undefined) {
      Timestamp.encode(toTimestamp(message.lastPull), writer.uint32(26).fork()).join();
    }
    if (message.poolId !== 0) {
      writer.uint32(32).uint64(message.poolId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ActiveWatcher {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseActiveWatcher();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.watcherId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.robots = RobotPair.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.lastPull = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.poolId = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ActiveWatcher {
    return {
      watcherId: isSet(object.watcherId)
        ? globalThis.String(object.watcherId)
        : isSet(object.watcher_id)
        ? globalThis.String(object.watcher_id)
        : "",
      robots: isSet(object.robots) ? RobotPair.fromJSON(object.robots) : undefined,
      lastPull: isSet(object.lastPull)
        ? globalThis.String(object.lastPull)
        : isSet(object.last_pull)
        ? globalThis.String(object.last_pull)
        : undefined,
      poolId: isSet(object.poolId)
        ? globalThis.Number(object.poolId)
        : isSet(object.pool_id)
        ? globalThis.Number(object.pool_id)
        : 0,
    };
  },

  toJSON(message: ActiveWatcher): unknown {
    const obj: any = {};
    if (message.watcherId !== "") {
      obj.watcherId = message.watcherId;
    }
    if (message.robots !== undefined) {
      obj.robots = RobotPair.toJSON(message.robots);
    }
    if (message.lastPull !== undefined) {
      obj.lastPull = message.lastPull;
    }
    if (message.poolId !== 0) {
      obj.poolId = Math.round(message.poolId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ActiveWatcher>, I>>(base?: I): ActiveWatcher {
    return ActiveWatcher.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ActiveWatcher>, I>>(object: I): ActiveWatcher {
    const message = createBaseActiveWatcher();
    message.watcherId = object.watcherId ?? "";
    message.robots = (object.robots !== undefined && object.robots !== null)
      ? RobotPair.fromPartial(object.robots)
      : undefined;
    message.lastPull = object.lastPull ?? undefined;
    message.poolId = object.poolId ?? 0;
    return message;
  },
};

function createBaseActiveIntervener(): ActiveIntervener {
  return { intervenerId: "", robotSerial: undefined, poolId: 0 };
}

export const ActiveIntervener: MessageFns<ActiveIntervener> = {
  encode(message: ActiveIntervener, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.intervenerId !== "") {
      writer.uint32(10).string(message.intervenerId);
    }
    if (message.robotSerial !== undefined) {
      writer.uint32(18).string(message.robotSerial);
    }
    if (message.poolId !== 0) {
      writer.uint32(24).uint64(message.poolId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ActiveIntervener {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseActiveIntervener();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.intervenerId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.robotSerial = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.poolId = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ActiveIntervener {
    return {
      intervenerId: isSet(object.intervenerId)
        ? globalThis.String(object.intervenerId)
        : isSet(object.intervener_id)
        ? globalThis.String(object.intervener_id)
        : "",
      robotSerial: isSet(object.robotSerial)
        ? globalThis.String(object.robotSerial)
        : isSet(object.robot_serial)
        ? globalThis.String(object.robot_serial)
        : undefined,
      poolId: isSet(object.poolId)
        ? globalThis.Number(object.poolId)
        : isSet(object.pool_id)
        ? globalThis.Number(object.pool_id)
        : 0,
    };
  },

  toJSON(message: ActiveIntervener): unknown {
    const obj: any = {};
    if (message.intervenerId !== "") {
      obj.intervenerId = message.intervenerId;
    }
    if (message.robotSerial !== undefined) {
      obj.robotSerial = message.robotSerial;
    }
    if (message.poolId !== 0) {
      obj.poolId = Math.round(message.poolId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ActiveIntervener>, I>>(base?: I): ActiveIntervener {
    return ActiveIntervener.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ActiveIntervener>, I>>(object: I): ActiveIntervener {
    const message = createBaseActiveIntervener();
    message.intervenerId = object.intervenerId ?? "";
    message.robotSerial = object.robotSerial ?? undefined;
    message.poolId = object.poolId ?? 0;
    return message;
  },
};

function createBaseActiveRobot(): ActiveRobot {
  return { robotSerial: "", poolId: 0 };
}

export const ActiveRobot: MessageFns<ActiveRobot> = {
  encode(message: ActiveRobot, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.robotSerial !== "") {
      writer.uint32(10).string(message.robotSerial);
    }
    if (message.poolId !== 0) {
      writer.uint32(16).uint64(message.poolId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ActiveRobot {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseActiveRobot();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.robotSerial = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.poolId = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ActiveRobot {
    return {
      robotSerial: isSet(object.robotSerial)
        ? globalThis.String(object.robotSerial)
        : isSet(object.robot_serial)
        ? globalThis.String(object.robot_serial)
        : "",
      poolId: isSet(object.poolId)
        ? globalThis.Number(object.poolId)
        : isSet(object.pool_id)
        ? globalThis.Number(object.pool_id)
        : 0,
    };
  },

  toJSON(message: ActiveRobot): unknown {
    const obj: any = {};
    if (message.robotSerial !== "") {
      obj.robotSerial = message.robotSerial;
    }
    if (message.poolId !== 0) {
      obj.poolId = Math.round(message.poolId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ActiveRobot>, I>>(base?: I): ActiveRobot {
    return ActiveRobot.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ActiveRobot>, I>>(object: I): ActiveRobot {
    const message = createBaseActiveRobot();
    message.robotSerial = object.robotSerial ?? "";
    message.poolId = object.poolId ?? 0;
    return message;
  },
};

function createBaseListActiveWatchersRequest(): ListActiveWatchersRequest {
  return {};
}

export const ListActiveWatchersRequest: MessageFns<ListActiveWatchersRequest> = {
  encode(_: ListActiveWatchersRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListActiveWatchersRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListActiveWatchersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ListActiveWatchersRequest {
    return {};
  },

  toJSON(_: ListActiveWatchersRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ListActiveWatchersRequest>, I>>(base?: I): ListActiveWatchersRequest {
    return ListActiveWatchersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListActiveWatchersRequest>, I>>(_: I): ListActiveWatchersRequest {
    const message = createBaseListActiveWatchersRequest();
    return message;
  },
};

function createBaseListActiveWatchersResponse(): ListActiveWatchersResponse {
  return { watchers: [] };
}

export const ListActiveWatchersResponse: MessageFns<ListActiveWatchersResponse> = {
  encode(message: ListActiveWatchersResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.watchers) {
      ActiveWatcher.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListActiveWatchersResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListActiveWatchersResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.watchers.push(ActiveWatcher.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListActiveWatchersResponse {
    return {
      watchers: globalThis.Array.isArray(object?.watchers)
        ? object.watchers.map((e: any) => ActiveWatcher.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListActiveWatchersResponse): unknown {
    const obj: any = {};
    if (message.watchers?.length) {
      obj.watchers = message.watchers.map((e) => ActiveWatcher.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListActiveWatchersResponse>, I>>(base?: I): ListActiveWatchersResponse {
    return ListActiveWatchersResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListActiveWatchersResponse>, I>>(object: I): ListActiveWatchersResponse {
    const message = createBaseListActiveWatchersResponse();
    message.watchers = object.watchers?.map((e) => ActiveWatcher.fromPartial(e)) || [];
    return message;
  },
};

function createBaseListActiveIntervenersRequest(): ListActiveIntervenersRequest {
  return {};
}

export const ListActiveIntervenersRequest: MessageFns<ListActiveIntervenersRequest> = {
  encode(_: ListActiveIntervenersRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListActiveIntervenersRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListActiveIntervenersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ListActiveIntervenersRequest {
    return {};
  },

  toJSON(_: ListActiveIntervenersRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ListActiveIntervenersRequest>, I>>(base?: I): ListActiveIntervenersRequest {
    return ListActiveIntervenersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListActiveIntervenersRequest>, I>>(_: I): ListActiveIntervenersRequest {
    const message = createBaseListActiveIntervenersRequest();
    return message;
  },
};

function createBaseListActiveIntervenersResponse(): ListActiveIntervenersResponse {
  return { interveners: [] };
}

export const ListActiveIntervenersResponse: MessageFns<ListActiveIntervenersResponse> = {
  encode(message: ListActiveIntervenersResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.interveners) {
      ActiveIntervener.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListActiveIntervenersResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListActiveIntervenersResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.interveners.push(ActiveIntervener.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListActiveIntervenersResponse {
    return {
      interveners: globalThis.Array.isArray(object?.interveners)
        ? object.interveners.map((e: any) => ActiveIntervener.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListActiveIntervenersResponse): unknown {
    const obj: any = {};
    if (message.interveners?.length) {
      obj.interveners = message.interveners.map((e) => ActiveIntervener.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListActiveIntervenersResponse>, I>>(base?: I): ListActiveIntervenersResponse {
    return ListActiveIntervenersResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListActiveIntervenersResponse>, I>>(
    object: I,
  ): ListActiveIntervenersResponse {
    const message = createBaseListActiveIntervenersResponse();
    message.interveners = object.interveners?.map((e) => ActiveIntervener.fromPartial(e)) || [];
    return message;
  },
};

function createBaseListActiveRobotsRequest(): ListActiveRobotsRequest {
  return {};
}

export const ListActiveRobotsRequest: MessageFns<ListActiveRobotsRequest> = {
  encode(_: ListActiveRobotsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListActiveRobotsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListActiveRobotsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ListActiveRobotsRequest {
    return {};
  },

  toJSON(_: ListActiveRobotsRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ListActiveRobotsRequest>, I>>(base?: I): ListActiveRobotsRequest {
    return ListActiveRobotsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListActiveRobotsRequest>, I>>(_: I): ListActiveRobotsRequest {
    const message = createBaseListActiveRobotsRequest();
    return message;
  },
};

function createBaseListActiveRobotsResponse(): ListActiveRobotsResponse {
  return { robots: [] };
}

export const ListActiveRobotsResponse: MessageFns<ListActiveRobotsResponse> = {
  encode(message: ListActiveRobotsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.robots) {
      ActiveRobot.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListActiveRobotsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListActiveRobotsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.robots.push(ActiveRobot.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListActiveRobotsResponse {
    return {
      robots: globalThis.Array.isArray(object?.robots) ? object.robots.map((e: any) => ActiveRobot.fromJSON(e)) : [],
    };
  },

  toJSON(message: ListActiveRobotsResponse): unknown {
    const obj: any = {};
    if (message.robots?.length) {
      obj.robots = message.robots.map((e) => ActiveRobot.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListActiveRobotsResponse>, I>>(base?: I): ListActiveRobotsResponse {
    return ListActiveRobotsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListActiveRobotsResponse>, I>>(object: I): ListActiveRobotsResponse {
    const message = createBaseListActiveRobotsResponse();
    message.robots = object.robots?.map((e) => ActiveRobot.fromPartial(e)) || [];
    return message;
  },
};

function createBaseClockInIntervenerRequest(): ClockInIntervenerRequest {
  return { intervenerId: "" };
}

export const ClockInIntervenerRequest: MessageFns<ClockInIntervenerRequest> = {
  encode(message: ClockInIntervenerRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.intervenerId !== "") {
      writer.uint32(10).string(message.intervenerId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClockInIntervenerRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClockInIntervenerRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.intervenerId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClockInIntervenerRequest {
    return {
      intervenerId: isSet(object.intervenerId)
        ? globalThis.String(object.intervenerId)
        : isSet(object.intervener_id)
        ? globalThis.String(object.intervener_id)
        : "",
    };
  },

  toJSON(message: ClockInIntervenerRequest): unknown {
    const obj: any = {};
    if (message.intervenerId !== "") {
      obj.intervenerId = message.intervenerId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClockInIntervenerRequest>, I>>(base?: I): ClockInIntervenerRequest {
    return ClockInIntervenerRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClockInIntervenerRequest>, I>>(object: I): ClockInIntervenerRequest {
    const message = createBaseClockInIntervenerRequest();
    message.intervenerId = object.intervenerId ?? "";
    return message;
  },
};

function createBaseClockInIntervenerResponse(): ClockInIntervenerResponse {
  return { intervener: undefined };
}

export const ClockInIntervenerResponse: MessageFns<ClockInIntervenerResponse> = {
  encode(message: ClockInIntervenerResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.intervener !== undefined) {
      ActiveIntervener.encode(message.intervener, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClockInIntervenerResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClockInIntervenerResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.intervener = ActiveIntervener.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClockInIntervenerResponse {
    return { intervener: isSet(object.intervener) ? ActiveIntervener.fromJSON(object.intervener) : undefined };
  },

  toJSON(message: ClockInIntervenerResponse): unknown {
    const obj: any = {};
    if (message.intervener !== undefined) {
      obj.intervener = ActiveIntervener.toJSON(message.intervener);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClockInIntervenerResponse>, I>>(base?: I): ClockInIntervenerResponse {
    return ClockInIntervenerResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClockInIntervenerResponse>, I>>(object: I): ClockInIntervenerResponse {
    const message = createBaseClockInIntervenerResponse();
    message.intervener = (object.intervener !== undefined && object.intervener !== null)
      ? ActiveIntervener.fromPartial(object.intervener)
      : undefined;
    return message;
  },
};

function createBaseClockOutIntervenerRequest(): ClockOutIntervenerRequest {
  return { intervenerId: "" };
}

export const ClockOutIntervenerRequest: MessageFns<ClockOutIntervenerRequest> = {
  encode(message: ClockOutIntervenerRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.intervenerId !== "") {
      writer.uint32(10).string(message.intervenerId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClockOutIntervenerRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClockOutIntervenerRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.intervenerId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClockOutIntervenerRequest {
    return {
      intervenerId: isSet(object.intervenerId)
        ? globalThis.String(object.intervenerId)
        : isSet(object.intervener_id)
        ? globalThis.String(object.intervener_id)
        : "",
    };
  },

  toJSON(message: ClockOutIntervenerRequest): unknown {
    const obj: any = {};
    if (message.intervenerId !== "") {
      obj.intervenerId = message.intervenerId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClockOutIntervenerRequest>, I>>(base?: I): ClockOutIntervenerRequest {
    return ClockOutIntervenerRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClockOutIntervenerRequest>, I>>(object: I): ClockOutIntervenerRequest {
    const message = createBaseClockOutIntervenerRequest();
    message.intervenerId = object.intervenerId ?? "";
    return message;
  },
};

function createBaseClockOutIntervenerResponse(): ClockOutIntervenerResponse {
  return {};
}

export const ClockOutIntervenerResponse: MessageFns<ClockOutIntervenerResponse> = {
  encode(_: ClockOutIntervenerResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClockOutIntervenerResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClockOutIntervenerResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ClockOutIntervenerResponse {
    return {};
  },

  toJSON(_: ClockOutIntervenerResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ClockOutIntervenerResponse>, I>>(base?: I): ClockOutIntervenerResponse {
    return ClockOutIntervenerResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClockOutIntervenerResponse>, I>>(_: I): ClockOutIntervenerResponse {
    const message = createBaseClockOutIntervenerResponse();
    return message;
  },
};

function createBaseClockInWatcherRequest(): ClockInWatcherRequest {
  return { watcherId: "" };
}

export const ClockInWatcherRequest: MessageFns<ClockInWatcherRequest> = {
  encode(message: ClockInWatcherRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.watcherId !== "") {
      writer.uint32(10).string(message.watcherId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClockInWatcherRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClockInWatcherRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.watcherId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClockInWatcherRequest {
    return {
      watcherId: isSet(object.watcherId)
        ? globalThis.String(object.watcherId)
        : isSet(object.watcher_id)
        ? globalThis.String(object.watcher_id)
        : "",
    };
  },

  toJSON(message: ClockInWatcherRequest): unknown {
    const obj: any = {};
    if (message.watcherId !== "") {
      obj.watcherId = message.watcherId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClockInWatcherRequest>, I>>(base?: I): ClockInWatcherRequest {
    return ClockInWatcherRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClockInWatcherRequest>, I>>(object: I): ClockInWatcherRequest {
    const message = createBaseClockInWatcherRequest();
    message.watcherId = object.watcherId ?? "";
    return message;
  },
};

function createBaseClockInWatcherResponse(): ClockInWatcherResponse {
  return { watcher: undefined };
}

export const ClockInWatcherResponse: MessageFns<ClockInWatcherResponse> = {
  encode(message: ClockInWatcherResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.watcher !== undefined) {
      ActiveWatcher.encode(message.watcher, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClockInWatcherResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClockInWatcherResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.watcher = ActiveWatcher.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClockInWatcherResponse {
    return { watcher: isSet(object.watcher) ? ActiveWatcher.fromJSON(object.watcher) : undefined };
  },

  toJSON(message: ClockInWatcherResponse): unknown {
    const obj: any = {};
    if (message.watcher !== undefined) {
      obj.watcher = ActiveWatcher.toJSON(message.watcher);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClockInWatcherResponse>, I>>(base?: I): ClockInWatcherResponse {
    return ClockInWatcherResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClockInWatcherResponse>, I>>(object: I): ClockInWatcherResponse {
    const message = createBaseClockInWatcherResponse();
    message.watcher = (object.watcher !== undefined && object.watcher !== null)
      ? ActiveWatcher.fromPartial(object.watcher)
      : undefined;
    return message;
  },
};

function createBaseClockOutWatcherRequest(): ClockOutWatcherRequest {
  return { watcherId: "" };
}

export const ClockOutWatcherRequest: MessageFns<ClockOutWatcherRequest> = {
  encode(message: ClockOutWatcherRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.watcherId !== "") {
      writer.uint32(10).string(message.watcherId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClockOutWatcherRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClockOutWatcherRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.watcherId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClockOutWatcherRequest {
    return {
      watcherId: isSet(object.watcherId)
        ? globalThis.String(object.watcherId)
        : isSet(object.watcher_id)
        ? globalThis.String(object.watcher_id)
        : "",
    };
  },

  toJSON(message: ClockOutWatcherRequest): unknown {
    const obj: any = {};
    if (message.watcherId !== "") {
      obj.watcherId = message.watcherId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClockOutWatcherRequest>, I>>(base?: I): ClockOutWatcherRequest {
    return ClockOutWatcherRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClockOutWatcherRequest>, I>>(object: I): ClockOutWatcherRequest {
    const message = createBaseClockOutWatcherRequest();
    message.watcherId = object.watcherId ?? "";
    return message;
  },
};

function createBaseClockOutWatcherResponse(): ClockOutWatcherResponse {
  return {};
}

export const ClockOutWatcherResponse: MessageFns<ClockOutWatcherResponse> = {
  encode(_: ClockOutWatcherResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClockOutWatcherResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClockOutWatcherResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ClockOutWatcherResponse {
    return {};
  },

  toJSON(_: ClockOutWatcherResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ClockOutWatcherResponse>, I>>(base?: I): ClockOutWatcherResponse {
    return ClockOutWatcherResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClockOutWatcherResponse>, I>>(_: I): ClockOutWatcherResponse {
    const message = createBaseClockOutWatcherResponse();
    return message;
  },
};

function createBaseGetNextRobotRequest(): GetNextRobotRequest {
  return { watcherId: "" };
}

export const GetNextRobotRequest: MessageFns<GetNextRobotRequest> = {
  encode(message: GetNextRobotRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.watcherId !== "") {
      writer.uint32(10).string(message.watcherId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetNextRobotRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetNextRobotRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.watcherId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetNextRobotRequest {
    return {
      watcherId: isSet(object.watcherId)
        ? globalThis.String(object.watcherId)
        : isSet(object.watcher_id)
        ? globalThis.String(object.watcher_id)
        : "",
    };
  },

  toJSON(message: GetNextRobotRequest): unknown {
    const obj: any = {};
    if (message.watcherId !== "") {
      obj.watcherId = message.watcherId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetNextRobotRequest>, I>>(base?: I): GetNextRobotRequest {
    return GetNextRobotRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetNextRobotRequest>, I>>(object: I): GetNextRobotRequest {
    const message = createBaseGetNextRobotRequest();
    message.watcherId = object.watcherId ?? "";
    return message;
  },
};

function createBaseGetNextRobotResponse(): GetNextRobotResponse {
  return { robots: undefined };
}

export const GetNextRobotResponse: MessageFns<GetNextRobotResponse> = {
  encode(message: GetNextRobotResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.robots !== undefined) {
      RobotPair.encode(message.robots, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetNextRobotResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetNextRobotResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.robots = RobotPair.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetNextRobotResponse {
    return { robots: isSet(object.robots) ? RobotPair.fromJSON(object.robots) : undefined };
  },

  toJSON(message: GetNextRobotResponse): unknown {
    const obj: any = {};
    if (message.robots !== undefined) {
      obj.robots = RobotPair.toJSON(message.robots);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetNextRobotResponse>, I>>(base?: I): GetNextRobotResponse {
    return GetNextRobotResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetNextRobotResponse>, I>>(object: I): GetNextRobotResponse {
    const message = createBaseGetNextRobotResponse();
    message.robots = (object.robots !== undefined && object.robots !== null)
      ? RobotPair.fromPartial(object.robots)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(dateStr: string): Timestamp {
  const date = new globalThis.Date(dateStr);
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): string {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis).toISOString();
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
